<template>
    <div class="quality-cards">
        <div class="container">
            <div class="cards-items">
                <div class="item" v-for="item in qualityPage.skills_cards">
                    <div class="item-img" :style="'background-image: url(' + item.img + ')'"></div>
                    <h3>{{ item.title }}</h3>
                    <div class="item-desc" v-html="item.desc"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'quality-cards-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            qualityPage: 'loadQualityPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/quality/quality-cards.scss';
    @import '@/styles/components/quality/respond/respond-quality-cards.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>